import React from 'react'

export default function Footer() {
  return (
    <footer>
      Készült 2026-ban. Minden jog fenntartva!
    </footer>
  )
}
